<template>
  <div class="Application">
    <section>
      <h1 class="title">{{ $t('jobs_page.header_five') }}</h1>

      <p class="paragraph">
        {{ $t('jobs_page.body_five') }}
      </p>
    </section>
    <section class="Application-Flow">
      <div
        :style="{
          '--current-step-pos': currentStep,
          display: currentStep === 1 ? 'none' : 'block',
        }"
        class="line"
      />
      <div class="line-dashes-parent">
        <div
          v-for="(_, i) in Array(numDashes).fill(0)"
          :key="i + 'a'"
          class="line-dash"
        />
      </div>
      <div
        v-for="i in [1, 2, 3, 4, 5]"
        :key="i + 'h'"
        class="step"
        @click="currentStep = i"
        :style="{
          '--step-col': i,
          visibility: i === currentStep ? 'hidden' : 'visible',
        }"
      >
        0{{ i }}
      </div>
      <div class="current-step" :style="{ '--current-step-col': currentStep }">
        0{{ currentStep }}
      </div>
      <div
        class="dot"
        v-for="i in [1, 2, 3, 4, 5]"
        :key="i + 'n'"
        @click="currentStep = i"
        :style="{ '--dot-col': i }"
      >
        <div class="inner-dot" :hidden="currentStep < i || undefined" />
        <img
          src="~@/assets/careers/checkmark.svg"
          class="check"
          :hidden="currentStep <= i || undefined"
        />
        <div class="outer-dot" :style="dotStyles(i)" />
      </div>
      <div
        v-for="([title, text, interviewLength], i) in interviewSteps"
        :key="i"
        :data-state="currentStep - 1 === i ? 'active' : null"
        v-touch:swipe.left="() => incrementInterviewSteps(i)"
        v-touch:swipe.right="() => decrementInterviewSteps(i)"
        class="flow-description"
      >
        <div class="flow-title-wrapper">
          <h4 class="flow-title">
            {{ title }}
          </h4>
          <span
            v-if="(!isMobile && i < interviewSteps.length - 1) || i === 0"
            class="flow-inc"
            @click="incrementInterviewSteps(i)"
            ><img
              src="~@/assets/careers/arrow.svg"
              alt="An clickable arrow pointing to the right"
            />
          </span>
        </div>
        <div v-if="i === 3">
          <div
            v-for="(paragraph, pIndex) in text"
            :key="pIndex"
            class="flow-text"
          >
            {{ paragraph }}
          </div>
        </div>
        <div v-else class="flow-text">
          {{ text }}
        </div>
        <div v-if="interviewLength.length" class="flow-time">
          <img src="~@/assets/careers/clock.svg" alt="A clock" />
          <span class="flow-time-amount">{{ interviewLength }} </span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMobile: window.innerWidth < 768,
      currentStep: 1,
      numDashes: window.innerWidth < 768 ? 10 : 20,
      interviewSteps: [
        [
          this.$i18n.t('jobs_page.step1_title'),
          this.$i18n.t('jobs_page.step1_txt'),
          '30 mins',
        ],
        [
          this.$i18n.t('jobs_page.step2_title'),
          this.$i18n.t('jobs_page.step2_txt'),
          '1 hour',
        ],
        [
          this.$i18n.t('jobs_page.step3_title'),
          this.$i18n.t('jobs_page.step3_txt'),
          '30-35 mins',
        ],
        [
          this.$i18n.t('jobs_page.step4_title'),
          this.$i18n.t('jobs_page.step4_txt').split('\n'),
          '45 mins',
        ],
        [
          this.$i18n.t('jobs_page.step5_title'),
          this.$i18n.t('jobs_page.step5_txt'),
          '',
        ],
      ],
    };
  },
  methods: {
    dotStyles(index) {
      if (this.currentStep < index) {
        return { width: '11px', height: '11px' };
      }
      if (this.currentStep === index) {
        return {};
      }

      return { width: '11px', height: '11px' };
    },
    incrementInterviewSteps(index) {
      // only five steps
      if (index < 4) {
        this.currentStep += 1;
      }
    },
    decrementInterviewSteps(index) {
      if (index > 0) {
        this.currentStep -= 1;
      }
    },
    resize() {
      if (window.innerWidth <= 768 && this.isMobile === false) {
        this.isMobile = true;
      } else if (window.innerWidth > 768 && this.isMobile === true) {
        this.isMobile = false;
      }
    },
  },
  mounted() {
    window.addEventListener('resize', () => this.resize);
  },
};
</script>

<style scoped>
.Application {
  --yellow: #ffdf22;
  overflow-x: hidden;
  --application-title-f-size: 30px;
  --application-text-f-size: 14px;
  --application-text-max-size: 80%;
  --flow-max-width: 80%;
}
.title {
  margin-top: 3em;
  text-align: center;
  color: var(--page-text-color);
  font-size: var(--application-title-f-size);
  font-weight: bold;
  font-family: 'Foco';
}
.paragraph {
  color: var(--page-text-color);
  font-size: var(--application-text-f-size);
  text-align: center;
  max-width: var(--application-text-max-size);
  margin: 2em auto 0 auto;
}
.Application-Flow {
  display: grid;
  margin: 2em auto 0 auto;
  max-width: var(--flow-max-width);
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 140px 1fr auto;
}
.line {
  height: 4px;
  width: 100%;
  background: var(--yellow);
  grid-column: 1 / calc(-7 + var(--current-step-pos));
  grid-row: 1;
  align-self: center;
}
.line-dashes-parent {
  grid-column: 1 / -2;
  grid-row: 1;
  align-self: center;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.line-dash {
  height: 2px;
  width: 13px;
  border-radius: 10px;
  background: var(--yellow);
}
.dot {
  grid-column: var(--dot-col);
  grid-row: 1;
  cursor: pointer;
  align-self: center;
  display: grid;
  justify-self: flex-start;
  place-items: center;
  width: max-content;
  height: max-content;
}

.dot > * {
  grid-area: 1 / 1;
}
.inner-dot {
  width: 13px;
  height: 13px;
  background: var(--yellow);
  z-index: 2;
}
.inner-dot,
.outer-dot {
  border-radius: 50%;
}
.outer-dot {
  width: 21px;
  height: 21px;
  background: white;
  border: 1px solid var(--yellow);
}

.flow-description {
  grid-column: 1 / -1;
}

.flow-title-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flow-title {
  position: relative;
  color: var(--page-text-color);
  font-size: 18px;
  height: min-content;
  font-weight: bold;
  width: max-content;
  margin-bottom: 1em;
}
.flow-inc {
  cursor: pointer;
}
.flow-title::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 15px;
  left: 0px;
  top: 55%;
  z-index: -1;
  background: var(--yellow);
}
.flow-text {
  color: var(--page-text-color);
  font-size: 16px;
  margin-bottom: 1em;
}
.flow-count {
  color: #a1b1b5;
  margin-right: 15px;
}
.flow-time {
  color: #a1b1b5;
  font-size: 14px;
  display: flex;
  justify-content: space-around;
  width: max-content;
}
.flow-time-amount {
  margin-left: 10px;
}
.step {
  height: min-content;
  color: #ecf1f2;
  cursor: pointer;
  font-size: 20px;
  grid-row: 1;
  align-self: center;
  margin-bottom: 3em;
  grid-column: var(--step-col);
}
.check {
  z-index: 2;
  pointer-events: none;
  transform: rotate(-90deg);
}
.current-step {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  grid-row: 1;
  grid-column: var(--current-step-col);
  align-self: center;
  margin-bottom: 5em;
  border-radius: 8px;
  background: #ffdf22;
  font-weight: bold;
  font-size: 20px;
  transform: translateX(-12px);
  position: relative;
}
.current-step::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  bottom: -12px;
  border-style: solid;
  border-width: 12px 8.5px 0 8.5px;
  border-color: #ffdf22 transparent transparent transparent;
}

.flow-description {
  transition-delay: 0s;
  transform: translateX(-400px);
  grid-row: 2;
}
.flow-description {
  transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
  transition-property: opacity, transform;
  opacity: 0;
}
.flow-description[data-state='active'] {
  display: block;
  transform: translateX(0px);
  opacity: 1;
}
.flow-description[data-state='active'] ~ div {
  transform: translateX(3000px);
  opacity: 0;
}
@media (min-width: 768px) {
  .Application {
    --application-title-f-size: 32px;
    --application-text-f-size: 18px;
    --application-text-max-size: 55%;
    --flow-max-width: 600px;
  }
}
</style>
